var React = require('react');

function PopoutVideo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M11 5h4v10H5v-4H1V1h10v4zm-1 0V4H2v6h3V5h5zM6 8v6h8V8H6z"}));
}

PopoutVideo.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = PopoutVideo;

PopoutVideo.default = PopoutVideo;
